module.exports = __webpack_public_path__ + "static/media/FAU-logo-01.86f1a935.png";